import { Path, useFormContext } from 'react-hook-form'

import { AbTestsCommonSchema } from 'features/ab-tests/forms/AbTestsCommonForm/abTestsCommonSchema'
import { RowDataVariant } from '../../types'
import { UseHideInput } from './types'

export const useHideInput = (): UseHideInput => {
  const { getValues } = useFormContext<AbTestsCommonSchema>()

  const hideInput = (prefix: RowDataVariant['prefix']): boolean => {
    type RelativePath = Path<NonNullable<AbTestsCommonSchema['variants']>[typeof variantKey]>

    const variantKey = prefix.split('.')[0] as keyof NonNullable<AbTestsCommonSchema['variants']>
    const relativePath = prefix.split('.').splice(1).join('.') as RelativePath
    const inputsToHide: RelativePath[] = [
      'general.advancedSettings.margin',
      'general.advancedSettings.mobileScaling',
    ]
    const isHidden: boolean =
      inputsToHide.includes(relativePath) &&
      getValues(`variants.${variantKey}.general.advancedSettings.targetingActionType`) !==
        'onPageLoadAndLazyLoad'

    return isHidden
  }

  return { hideInput }
}
